module.exports = __webpack_public_path__ + "img/jiaru_hk.666459ff.png";